import React from "react";
import "./Banner.css";

export default function Banner() {
  return (
    <div className="app-banner" aria-hidden="true">
      SessionHoster by TBD
    </div>
  );
}
